import { gunzip } from '@exodus/crypto/compress'
import { cleanupTrusted } from '@exodus/svg-safe'

export const unzipIcon = async (base64) => {
  const buff = Buffer.from(base64, 'base64')
  const unzip = await gunzip(buff, { format: 'buffer' })
  return cleanupTrusted(unzip.toString('utf8'))
}
